// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "teams-sdk" + ".js?h=" + "234086d5861bc75e408e" + "";
};